import type { WidgetType } from '@/types/dashboardConfig'

/** 控件默认尺寸（0-1 分数，相对于面板宽/高） */
export const DEFAULT_WIDGET_SIZE: Record<WidgetType, { w: number; h: number }> = {
  ValueCard:     { w: 3 / 12, h: 2 / 12 },
  Gauge:         { w: 3 / 12, h: 3 / 12 },
  StatusBadge:   { w: 2 / 12, h: 1 / 12 },
  TrendLine:     { w: 4 / 12, h: 3 / 12 },
  AlarmList:     { w: 4 / 12, h: 4 / 12 },
  ControlButton: { w: 2 / 12, h: 1 / 12 },
  ToggleSwitch:  { w: 2 / 12, h: 1 / 12 },
  FocusButton:   { w: 2 / 12, h: 1 / 12 },
}

export const WIDGET_TYPE_LABELS: Record<WidgetType, string> = {
  ValueCard:     '数值卡',
  Gauge:         '仪表盘',
  StatusBadge:   '状态徽标',
  TrendLine:     '趋势折线',
  AlarmList:     '告警列表',
  ControlButton: '控制按钮',
  ToggleSwitch:  '开关',
  FocusButton:   '聚焦对象',
}
